// extracted by mini-css-extract-plugin
module.exports = {"icomoon-font":"CmsRowHeadline_icomoon-font__3qaIJ","CmsRowHeadline":"CmsRowHeadline_CmsRowHeadline__2LxCP"};